//after every theme change run tailwind-colors.js to generate _tailwind-colors.scss
const theme = {
  color: {
    nova: {
      base: {
        white: "#FFFFFF",
        solid: {
          10: "#F5F8F8",
          20: "#ECF1F5",
          40: "#DBE0E4",
        },
        black: "#041C1B",
      },
      brand: {
        darkblue: {
          40: "#CBE6EF",
          60: "#14283A",
          100: "#041420",
        },
        primary: {
          80: "#007A73",
          100: "#065954",
        },
        accent: {
          80: "#FFC942",
          100: "#F6B615",
        },
      },
      functional: {
        success: "#12AF51",
        error: "#CC2500",
      },
      transparency: {
        black: {
          10: "rgba(4, 28, 27, 0.1)",
          20: "rgba(4, 28, 27, 0.2)",
          40: "rgba(4, 28, 27, 0.4)",
          60: "rgba(4, 28, 27, 0.6)",
          70: "rgba(4, 28, 27, 0.7)",
        },
        white: {
          10: "rgba(255, 255, 255, 0.1)",
          20: "rgba(255, 255, 255, 0.2)",
          40: "rgba(255, 255, 255, 0.4)",
          60: "rgba(255, 255, 255, 0.6)",
        },
      },
    },
    master: {
      base: {
        default: "#FFFFFF",
        secondary: "#F8F8F5",
        black: "#22202F",
        alt: {
          default: "#90A9A6",
          secondary: "#C8D2D1",
          alt: "#677574",
          disabled: "#435652",
        },
      },
      primary: {
        default: "#008078",
        secondary: "#005752",
        alt: "#E8FAF7",
      },
      secondary: {
        default: "#07253A",
        secondary: "#0F3956",
        alt: "#DCE9EA",
      },
      functional: {
        error: "#CC2500",
        success: "#24BB60",
        disabled: "#9BADAB",
      },
    },
  },
};

export default theme;
